import {
  AnalyticsPlot,
  AnalyticsLeadPlot,
} from '../../analytics/types/analytics.types';

const SQUARE_SIZE = 30; // px

export const GRID_UNIT_SIZE = SQUARE_SIZE / 25; // px - the width of a grid line => 1/25 of a square

export const squareToPixel = (squares: number) => squares * SQUARE_SIZE;

export const SCATTER_DOTS_SIZE = squareToPixel(1.5 / 8);

export const STRIP_SCATTER_DOTS_SIZE = squareToPixel(2 / 8);

export const STRIP_WIDTH = squareToPixel(50);

export const GRID_MS = 200; // ms

export const GRID_MV = 0.5; // mV

export const TOP_PLOT_HEIGHT = squareToPixel(10);

export const TOP_PLOT_HEADER_HEIGHT = squareToPixel(1);

export const TOP_PLOT_FOOTER_HEIGHT = squareToPixel(1);

export const TEXT_HEIGHT = squareToPixel(0.45);

export const TEXT_OFFSET = squareToPixel(0.9);

export const HANDLE_SIZE = 6 * GRID_UNIT_SIZE;
export const CORNER_SIZE = 15 * GRID_UNIT_SIZE;

export const THREE_LEAD = 'three-lead';
export const RAW_SIGNAL = 'raw-signal';
export const NOISE = 'noise';
export const ZOOM = 'zoom';
export const SINGLE_LEAD = 'single-lead';
export const MINUTE = 'minute';

export const isOfTypeChangeLead = (
  plot: AnalyticsPlot | undefined,
): plot is AnalyticsLeadPlot =>
  ['zoom', 'lead', 'raw'].some((value) => value === plot);

export const isOfTypeChangeAmplitude = (
  plot: AnalyticsPlot | undefined,
): plot is AnalyticsPlot =>
  ['zoom', 'lead', 'raw', 'noise'].some((value) => value === plot);
